export default __webpack_public_path__ + "static/technical-742b0fc4fd3b00c6685f78d132aa09d0.jpg";